export const DEFAULT_WSS_URL = "wss://files.ysafe.io";

export interface SdkConfig {
  wsUrl?: string;
  poolSize?: number; // Minimum of 2 connections required in the pool
  reconnectDelayMs?: number;
}

export const defaultSdkConfig: Required<SdkConfig> = {
  wsUrl: DEFAULT_WSS_URL,
  poolSize: 8,
  reconnectDelayMs: 3000,
};

export const defaultWorkerConfig: Required<SdkConfig> = {
  wsUrl: DEFAULT_WSS_URL,
  poolSize: 2,
  reconnectDelayMs: 3000,
};

export const defaultDataSdkConfig: Required<SdkConfig> = {
  wsUrl: DEFAULT_WSS_URL,
  poolSize: 4,
  reconnectDelayMs: 3000,
};
